import styled from "styled-components";
import {TextDetail, TitleSection} from "../../course_details/components/Styles";
import {ButtonLink} from "../../../styles/Button";
import {TypeTitle, ContentContainer} from "../../../styles/Products";
import Color from "../../../assets/Colors";

export const ExperienceComp = styled(ContentContainer)`
   // width: 100%;
   padding: 0;
   display flex;
   margin-bottom: 10em;

   @media screen and (max-width: 500px) {
      flex-direction: column;
      margin-bottom: 6em;
   }

`;

export const SectionExp = styled.div`
   width: 50%;
   height: 70vmin;
   padding: 0;

   display: flex;
   justify-content: flex-end;
   align-items: center;
   flex-direction: column;

   &.img {
      background-color: #394136;
      background-size: cover;
   }

   @media screen and (max-width: 1600px) {
      height: 75vmin;
   }

   @media screen and (max-width: 500px) {
      width: 100%;
      &:first-child {
         height: 45vmax;
      }
      &:last-child {
         height: auto;
         margin-top: -2.5em;
         z-index: 10000;
      }
   }
`;

export const DetailsSection = styled.div`
   width: 80%;
   margin: 0 auto;
   box-sizing: border-box;

   & ${TextDetail} {
      font-size: 1.1em;
      margin-bottom: 6em;
      display: block;
   }

   & ${ButtonLink} {
      display: block;
      width: 50%;
      margin: 0 auto;
      padding: 1.2em;
      font-size: 1.2em;
      margin-bottom: 0;
   }

   @media screen and (max-width: 1600px) {
      & ${TextDetail} {
         font-size: 0.8em;
         margin-bottom: 3em;
         display: block;
      }

      & ${ButtonLink} {
         padding: 1em;
         font-size: 0.9em;
      }
   }

   @media screen and (max-width: 500px) {
      width: 90%;
      padding: 0 0.5em;
      background: white;

      & ${ButtonLink} {
         width: 100%;
         color: white;
         background: ${Color.primary};
      }
   }
`;

export const SectionTitle = styled.div`
   width: 92%;
   background: white;
   position: relative;
   padding: 2.5em 1em;
   margin-bottom: -1em;

   & .iconBox {
      position: absolute;
      top: -2em;
   }

   & ${TitleSection} {
      font-weight: 400;
      text-transform: initial;
   }

   @media screen and (max-width: 1600px) {
      .iconBox {
         width: 2.5em;
         height: 2.5em;
         top: -1em;
      }

      & ${TypeTitle} {
         font-size: 0.9em;
         margin-bottom: 0.5em;
      }

      & ${TitleSection} {
         font-size: 1em;
      }
   }
   @media screen and (max-width: 500px) {
      width: 92%;
      padding: 1.5em 0.5em;
      padding-bottom: 5em;

      & .iconBox {
         width: 2em;
         height: 2em;
         top: -1em;
      }

      & ${TypeTitle} {
         font-size: 0.76em;
         margin-bottom: 0.3em;
      }

      & ${TitleSection} {
         font-size: 0.88em;
      }
   }
`;

export const DateInfo = styled.div`
   width: 100%;
   display: flex;
   justify-content: space-around;
   align-items: center;
   margin-bottom: 2em;

   & .section {
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      & img {
         margin-right: 3em;
      }
   }

   & .line {
      border-right: 1px solid grey;
      height: 3em;
   }

   @media screen and (max-width: 1600px) {
      & .section {
         & img {
            margin-right: 1.8em;
            width: 1.5em;
            height: 1.5em;
         }
      }
      & .line {
         height: 2em;
      }
   }
`;

export const TextInfo = styled.p`
   font-weight: 400;
   color: ${Color.primary};
   font-size: 1.5em;
   line-height: 1.6em;
   @media screen and (max-width: 1600px) {
      font-size: 0.8em;
   }
`;

export const TitleInfo = styled(TextInfo)`
   font-weight: 200;
   color: ${Color.textColor};
`;
